module.exports = __webpack_public_path__ + "static/jawline-after-fad7f26eed98096fb70df0ccb30f6d66.jpg";